import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'woods-loading',
  templateUrl: './woods-loading.component.html',
  styleUrls: ['./woods-loading.component.scss']
})
export class WoodsLoadingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
